export default function IconArrowRight({className}) {
	return (
		<svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M10 0L20 10L10 20L8.792 18.792L16.7298 10.8542H0V9.14582H16.7298L8.792 1.208L10 0Z" fill="currentColor"/></svg>
	)
}